import { useContext } from "react";
import { ProjectStoreFormStoreApi } from "../stores/projectStoreFormStore";
import { ProjectStoreFormStoreContext } from "../stores/ProjectStoreFormContext";

export function useProjectStoreFormStoreApi(): ProjectStoreFormStoreApi {
  const store = useContext(ProjectStoreFormStoreContext);
  if (!store) {
    throw new Error(
      "useProjectStoreFormStoreApi must be used within a ProjectStoreProvider",
    );
  }
  return store;
}
